if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form.querySelector('[name="id"]')) {
        this.form.querySelector('[name="id"]').disabled = false;
      }
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification') || document.querySelector('cart-items');
      this.useSuccessMessage = this.cart && this.cart.tagName.toLowerCase() !== 'cart-notification';
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    disconnectedCallback() {
      if (this.hasAttribute('data-rp-v2-plp-form')) this.rpV2RequestController?.abort();
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const isRpV2PlpForm = this.hasAttribute('data-rp-v2-plp-form');
      if (isRpV2PlpForm) this.error = false;
      let rpV2RequestSucceeded = false;
      let rpV2RequestError = null;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      if (isRpV2PlpForm) {
        this.rpV2RequestController = new AbortController();
        config.signal = this.rpV2RequestController.signal;
      }

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            document.dispatchEvent(new CustomEvent('afterAddCartError', {detail: {
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message
            }}));
            if (isRpV2PlpForm) rpV2RequestError = response.description || response.message;
            this.handleErrorMessage(isRpV2PlpForm ? rpV2RequestError : response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          if(!this.error) {
            this.error = false;
            if(this.useSuccessMessage) {
              pushSuccessMessage(window.cartStrings.success);
            }

            const quickAddDrawer = this.closest('quick-add-drawer');
            if (quickAddDrawer) {
              document.body.addEventListener('drawerClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddDrawer.close();
            } else {
              this.cart.renderContents(response);
            }
            document.dispatchEvent(new CustomEvent('afterCartChanged', {detail: {
              productVariantId: formData.get('id'),
              source: 'product-form',
              cartData: response
            }}));
            if (isRpV2PlpForm) rpV2RequestSucceeded = true;
          }
        })
        .catch((e) => {
          if (isRpV2PlpForm) {
            if (e.name !== 'AbortError') {
              rpV2RequestError = e.message || window.cartStrings?.error || 'Unable to add this item. Please try again.';
              this.handleErrorMessage(rpV2RequestError);
            }
          } else {
            console.error(e);
          }
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty') && (!isRpV2PlpForm || rpV2RequestSucceeded)) this.cart.classList.remove('is-empty');
          if (!this.error || isRpV2PlpForm) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          if (isRpV2PlpForm) {
            const aborted = this.rpV2RequestController?.signal.aborted || false;
            this.rpV2RequestController = null;
            this.dispatchEvent(new CustomEvent('rp-v2:request-complete', {
              bubbles: true,
              detail: { success: rpV2RequestSucceeded, variantId: formData.get('id'), error: rpV2RequestError, aborted }
            }));
          }
        });
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text && this.submitButtonText) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        if(this.submitButtonText) {
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if(errorMessage && !this.errorMessageWrapper) {
        pushErrorMessage(errorMessage);
      }
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
